<template>
    <div
        @click="onClick"
        class="extra-select-input-container"
    >
        <span
            v-if="required"
            class="required"
        >*</span>
        <div class="avator-selector">
            <template v-if="isAvatorSelector">
                <img
                    v-if="selectedToArray && selectedToArray.length"
                    :src="selectedToArray[0]"
                    alt=""
                    class="img-selected"
                >
                <v-icon
                    v-else
                    name="img_selector"
                    class="img-selector"
                />
            </template>
            
            <template v-if="selectedToArray && selectedToArray.length">
                <a class="extra-select-input-trigger">修改</a>
            </template>
            <template v-else>
                <!-- 头像选择器没有 '选择' -->
                <a class="extra-select-input-trigger" v-if="!isAvatorSelector">选择</a>
            </template>

            <span
                v-if="error"
                class="error"
            >{{ error }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExtraSelectInput',
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '请选择',
        },
        selected: {
            type: [String, Number, Array],
            default: () => [],
        },
        error: {
            type: String,
            default: '',
        },
        // 是否是头像选择器
        isAvatorSelector: Boolean,
    },
    computed: {
        selectedToArray() {
            // 一些字段的默认值是 0 或 '0' 转换之后希望得到一个空数组 而不是将其转为数组的一项
            const selected = this.selected == 0 ? [] : this.selected;
            return Array.isArray(selected) ? selected : [selected];
        },
        options() {
            return this.selectedToArray.map(value => ({
                text: value,
                value,
            })).concat([{ text: '空', value: '空' }]);
        },
    },
    methods: {
        onOpenExtraSelectVisibleChange(visible) {
            if (visible) {
                this.$nextTick(() => {
                    // 这里只是使用vhtml1的下拉框样式来模拟展示，实际并不需要使用下拉能力，因此这里通过点击后立马关闭selector弹窗并弹出自定义的弹窗
                    const selectorPopper = this.$refs.extraSelectInputRef
                        && this.$refs.extraSelectInputRef.$refs.selector;
                    if (selectorPopper) {
                        selectorPopper.hide();
                    }
                });
            }
        },
        onClick() {
            this.$emit('click');
        },
    },
};
</script>

<style>
</style>
<style lang="less" scoped>
.extra-select-input-container{
    background-color: #f8f9fb;
    cursor: pointer;
}
.extra-select-input-container {
    display: flex;

    .required {
        color: var(--color-error-normal);
        position: absolute;
        margin-top: 3px;
        margin-left: -13px;
    }

    .error {
        color: red;
    }
}

.avator-selector{
    display: flex;
    align-items: center;

    .img-selected,
    .img-selector{
        width: 48px;
        height: 48px;
        margin-right: 10px;
        border-radius: 50%;
    }

}
</style>
